import { MapVariants } from "constants/keys";

import React from "react";

import { MTSButton } from "components/mts-button";
import { useContextMap } from "hooks/use-context-map";
import { IMapVariants } from "interfaces/local";

import classes from "./map-switcher.module.css";

export const MapSwitcher = (): JSX.Element => {
  const { mapVariant, updateMapVariant } = useContextMap();

  const handleUpdateMapVariant = (newMapVariant: IMapVariants): void => {
    if (newMapVariant !== mapVariant) {
      updateMapVariant(newMapVariant);
    }
  };

  return (
    <div className={classes.blockMapSwitcher}>
      <MTSButton
        size="S"
        variant={mapVariant === MapVariants.egis ? "secondary" : "ghost"}
        onClick={() => {
          handleUpdateMapVariant(MapVariants.egis);
        }}
      >
        ЕГИС
      </MTSButton>
      <MTSButton
        size="S"
        variant={mapVariant === MapVariants.yandex ? "secondary" : "ghost"}
        onClick={() => {
          handleUpdateMapVariant(MapVariants.yandex);
        }}
      >
        Яндекс
      </MTSButton>
    </div>
  );
};
